import {
  CheckSquare,
  Grid,
  Layers,
  User,
  UserPlus,
  MapPin,
  Settings,
  Lock,
  CheckCircle,
  Globe,
  TrendingUp,
  Briefcase,
  Users,
  Phone,
  UserX,
  PieChart,
  Code,
  Calendar,
  DollarSign,
  Clock,
  LifeBuoy,
} from "react-feather";
import React from "react";

// Fetch pending overtime count for sidebar badge
const usePendingOvertimeCount = () => {
  return 0;
};

// Pending badge component
const PendingBadge = ({ count }) => {
  if (!count) return null;
  return (
    <span
      style={{
        marginLeft: "auto",
        minWidth: 20,
        height: 20,
        padding: "0 6px",
        borderRadius: 999,
        background: "#f43f5e",
        color: "#fff",
        fontSize: "0.65rem",
        fontWeight: 800,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 1,
        flexShrink: 0,
        boxShadow: "0 2px 6px rgba(244,63,94,0.4)",
      }}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
};

export { usePendingOvertimeCount, PendingBadge };
export const MENUITEMS = [
  {
    menutitle: "Master",
    Items: [
      {
        title: "Master",
        icon: Layers,
        type: "sub",
        active: false,
        children: [
          { path: `/center`, title: "Center", type: "link", icon: MapPin },
          { path: `/position`, title: "Position", type: "link", icon: User },
          {
            path: `/organization`,
            title: "Organization",
            type: "link",
            icon: Globe,
          },
        ],
      },
    ],
  },
  {
    menutitle: "HR",
    Items: [
      {
        title: "HR",
        icon: Grid,
        type: "sub",
        active: false,
        children: [
          {
            path: `/HrDashboard`,
            title: "Dashboard",
            type: "link",
            icon: Grid,
          },
          {
            path: `/staff-attendance`,
            title: "Staff Attendance",
            type: "link",
            icon: User,
          },
          {
            path: `/attendanceApproval`,
            title: "Attendance Approval",
            type: "link",
            icon: CheckSquare,
          },
          {
            path: `/leaveApproval`,
            title: "Leave Approval",
            type: "link",
            icon: CheckCircle,
          },
          { path: `/setting`, title: "Setting", type: "link", icon: Settings },
          {
            path: `/staff`,
            title: "Staff",
            type: "link",
            icon: UserPlus,
          },
          {
            path: `/payrollTemplates`,
            title: "Payroll",
            type: "link",
            icon: DollarSign,
          },
          {
            path: `/overtimeRequests`,
            title: "Overtime",
            type: "link",
            icon: Clock,
            badge: "pendingOvertime",
          },
        ],
      },
    ],
  },
  {
    menutitle: "Role",
    Items: [
      {
        path: "/role",
        icon: Lock,
        title: "Role",
        active: false,
        type: "link",
      },
    ],
  },
  {
    menutitle: "Sales",
    Items: [
      {
        title: "Sales",
        icon: Briefcase,
        type: "sub",
        active: false,
        children: [
          {
            path: `/SalesDashboard`,
            title: "Dashboard",
            type: "link",
            icon: PieChart,
          },
          {
            path: `/lead`,
            title: "Lead",
            type: "link",
            icon: TrendingUp,
          },
          {
            path: `/Company`,
            title: "Company",
            type: "link",
            icon: Users,
          },
          {
            path: `/Contacts`,
            title: "Contact",
            type: "link",
            icon: Phone,
          },
          {
            path: `/deal`,
            title: "Deal",
            type: "link",
            icon: CheckCircle,
          },
          {
            path: `/Aliased`,
            title: "Aliased",
            type: "link",
            icon: UserX,
          },
          {
            path: `/Technology`,
            title: "Technology",
            type: "link",
            icon: Code,
          },
          {
            path: `/interview`,
            title: "Interview",
            type: "link",
            icon: Calendar,
          },
        ],
      },
    ],
  },
  {
    menutitle: "Inquiry",
    Items: [
      {
        title: "Inquiry",
        icon: Phone,
        type: "sub",
        active: false,
        children: [{ path: `/inquiry`, title: "Inquiry", type: "link", icon: Phone }],
      },
    ],
  },
  {
    menutitle: "Support",
    Items: [
      {
        path: "/support",
        icon: LifeBuoy,
        title: "Support",
        active: false,
        type: "link",
      },
    ],
  },
];
